// Shared Supabase config — anon key only (safe for frontend)
// Service role key is NEVER used in frontend code
export const SUPABASE_URL = 'https://yawtkdwhvccveuttvffu.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlhd3RrZHdodmNjdmV1dHR2ZmZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyNjg0MjksImV4cCI6MjA4ODg0NDQyOX0.JY_LvhG4gRmSpavC9gzw7jj2wBudIizNK6t4e5Zq_8o';

// Edge function base URL
export const FUNCTIONS_URL = `${SUPABASE_URL}/functions/v1`;
